/**
 * Eros PLP filter tray (ADR-205) - the ONLY file that touches the Prestige / Search &
 * Discovery facet form. Reads nothing from it for rendering (labels and counts come from the
 * Liquid JSON mirror); it WRITES: finds the real <input> of an option, flips it, and fires
 * the same events Prestige uses, so facets-form builds the URL and theme.js swaps the
 * section exactly as it does for the drawer/sidebar (facet:update). The original inputs are
 * never removed or replaced, so no-JS and the legacy UI keep working.
 *
 * Prestige contract (assets/theme.js, FacetsForm):
 *   - a bubbling `change` on any input inside <facets-form> marks it dirty (and prefetches);
 *   - a `submit` on the form dispatches `facet:update` with the built URL (only when dirty);
 *   - <facet-link> clicks dispatch `facet:update` with a plain URL (used for "clear all").
 */
(function (root) {
  'use strict';
  var ns = (root.ErosPlpTray = root.ErosPlpTray || {});

  var SUBMIT_DELAY_MS = 320; /* batches quick taps into one request */
  var timer = null;

  /* The drawer form always exists (non-update-on-change); the sidebar form is a twin. */
  function findForm(sectionEl) {
    var scope = sectionEl || document;
    return (
      scope.querySelector('facets-drawer facets-form form') ||
      scope.querySelector('facets-form form') ||
      document.querySelector('facets-drawer facets-form form') ||
      document.querySelector('facets-form form')
    );
  }

  function inputsByName(form, name) {
    var all = form.querySelectorAll('input');
    var out = [];
    for (var i = 0; i < all.length; i++) if (all[i].name === name) out.push(all[i]);
    return out;
  }

  function findInput(form, name, value) {
    var list = inputsByName(form, name);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].value) === String(value)) return list[i];
    }
    return null;
  }

  function fire(el, type) {
    var ev;
    if (typeof Event === 'function') ev = new Event(type, { bubbles: true, cancelable: true });
    else {
      ev = document.createEvent('Event');
      ev.initEvent(type, true, true);
    }
    el.dispatchEvent(ev);
  }

  /* Debounced submit. Dispatching `submit` directly (as Prestige's own fallback does) skips
     browser constraint validation on the hidden price inputs. */
  function scheduleSubmit(form) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      fire(form, 'submit');
    }, SUBMIT_DELAY_MS);
  }

  /** Set a checkbox option on/off. Returns false when the form has no such input. */
  function setOption(form, name, value, on) {
    var input = findInput(form, name, value);
    if (!input) return false;
    if (input.checked !== on) {
      input.checked = on;
      fire(input, 'change');
    }
    scheduleSubmit(form);
    return true;
  }

  /** gte / lte: numbers or null to clear that side. */
  function setPrice(form, gteName, lteName, gte, lte) {
    var g = inputsByName(form, gteName)[0];
    var l = inputsByName(form, lteName)[0];
    if (!g || !l) return false;
    g.value = gte === null || gte === undefined ? '' : String(gte);
    l.value = lte === null || lte === undefined ? '' : String(lte);
    fire(g, 'change');
    scheduleSubmit(form);
    return true;
  }

  /* Same path <facet-link> takes: a URL carrying section_id into the global facet:update. */
  function navigate(sectionId, url) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    document.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: u } }));
  }

  function cancelPending() {
    if (timer) clearTimeout(timer);
    timer = null;
  }

  ns.form = {
    findForm: findForm,
    findInput: findInput,
    setOption: setOption,
    setPrice: setPrice,
    navigate: navigate,
    cancelPending: cancelPending
  };
})(typeof window !== 'undefined' ? window : globalThis);
